// Phones: the promo tiles are a swipeable carousel that advances by itself, loops back to the first tile, and shows
// dots. Touching the row pauses the autoplay for a few seconds. Wider screens keep the plain grid.
const row = document.querySelector('[data-promo-tiles-row]');
if (row) {
  const mobile = window.matchMedia('(max-width: 749px)');
  const tiles = Array.from(row.children);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const dots = document.createElement('div');
  dots.className = 'promo-tiles__dots';
  tiles.forEach((tile, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'promo-tiles__dot';
    dot.setAttribute('aria-label', `Tile ${index + 1}`);
    dot.addEventListener('click', () => go(index));
    dots.append(dot);
  });
  row.after(dots);

  let current = 0;
  let pausedUntil = 0;
  const go = (index) => {
    current = (index + tiles.length) % tiles.length;
    const tile = tiles[current];
    row.scrollTo({ left: tile.offsetLeft - (row.clientWidth - tile.offsetWidth) / 2, behavior: 'smooth' });
  };
  const sync = () => {
    const center = row.scrollLeft + row.clientWidth / 2;
    let best = 0;
    tiles.forEach((tile, index) => {
      if (Math.abs(tile.offsetLeft + tile.offsetWidth / 2 - center) < Math.abs(tiles[best].offsetLeft + tiles[best].offsetWidth / 2 - center)) best = index;
    });
    current = best;
    Array.from(dots.children).forEach((dot, index) => dot.classList.toggle('is-active', index === best));
  };
  row.addEventListener('scroll', sync, { passive: true });
  ['touchstart', 'pointerdown'].forEach((type) => row.addEventListener(type, () => { pausedUntil = Date.now() + 6000; }, { passive: true }));
  sync();

  if (!reduceMotion) {
    setInterval(() => {
      if (!mobile.matches || document.hidden || Date.now() < pausedUntil) return;
      go(current + 1);
    }, 3800);
  }
}
